import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import ApiService from "../../network/ApiService";
import { FiMenu, FiX, FiChevronDown, FiChevronUp } from "react-icons/fi";

function Navbar(props) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [mobileDropdowns, setMobileDropdowns] = useState({});
  const [messages, setMessages] = useState([]);
  const { fetchMessages } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const languageStatus = sessionStorage.getItem("language");

  const aboutDropdownRef = useRef(null);
  const newsDropdownRef = useRef(null);
  const eservicesDropdownRef = useRef(null);

  useEffect(() => {
    const fetchStaffMessages = async () => {
      try {
        const response = await fetchMessages();
        setMessages(response.data.mapOfIdAndDisplayLabels);
      } catch (error) {
        console.log(error.message);
      }
    };
    if (organizationId) fetchStaffMessages();
  }, [organizationId]); 

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        (aboutDropdownRef.current && aboutDropdownRef.current.contains(e.target)) ||
        (newsDropdownRef.current && newsDropdownRef.current.contains(e.target)) ||
        (eservicesDropdownRef.current && eservicesDropdownRef.current.contains(e.target))
      )
        return;
      setOpenDropdown(null);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (menu) => setOpenDropdown(openDropdown === menu ? null : menu);
  const toggleMobileDropdown = (menu) => {
    setMobileDropdowns((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  const menuItems = [
    { name: languageStatus === "en" ? "Home" : "गृहपृष्ठ", to: "/" },
    {
      name: languageStatus === "en" ? "About Us" : "हाम्रो बारेमा",
      to: "",
      dropdown: "about",
      subItems: [
        { name: languageStatus === "en" ? "Office Information" : "संस्थाको जानकारी", to: "/about" },
        ...Object.keys(messages).map((key) => ({
          name:
            languageStatus === "en"
              ? `${messages[key].designation}'s Speech`
              : `${messages[key].designationNP}को मन्तव्य`,
          to: `/messages/${key}`,
        })),
      ],
    },
    {
      name: languageStatus === "en" ? "News & Notices" : "सुचना/गतिविधि",
      to: "/",
      dropdown: "news",
      subItems: [
        { name: languageStatus === "en" ? "News" : "समाचार", to: "/news" },
        { name: languageStatus === "en" ? "Notices" : "सुचना/गतिविधि", to: "/notices" },
      ],
    },
    { name: languageStatus === "en" ? "Our Services" : "हाम्रा सेवाहरू", to: "/our-services" },
    {
      name: languageStatus === "en" ? "E-Services" : "ई-सर्विसेस",
      to: "/",
      dropdown: "eservices",
      subItems: [
        { name: languageStatus === "en" ? "Outstanding Report" : "बक्यौता विवरण", to: "/outstanding-report" },
        { name: languageStatus === "en" ? "Complain Service" : "गुनासो सेवा", to: "/complain-service" },
        { name: languageStatus === "en" ? "Water Schedule" : "पानी बितरण तालिका", to: "/water-schedule" },
        { name: languageStatus === "en" ? "Meter Reading Schedule" : "रिडिङ्ग तालिका", to: "/meter-reading-schedule" },
      ],
    },
    { name: languageStatus === "en" ? "Photo Gallery" : "फोटो ग्यालरी", to: "/gallery" },
    { name: languageStatus === "en" ? "Downloads" : "डाउनलोड", to: "/downloads" },
    { name: languageStatus === "en" ? "Members" : "सदस्यहरू", to: "/team" },
    { name: languageStatus === "en" ? "Contact Us" : "सम्पर्क", to: "/contact" },
  ];

  return (
    <div style={{ position: "relative", zIndex: 9999, backgroundColor: "#0f2495" }}>
      <div
        className="uk-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 1rem",
          height: "60px",
          position: "relative",
        }}
      >
        {/* Desktop Menu */}
        <ul
          className="uk-navbar-nav uk-visible@l"
          style={{
            display: "flex",
            gap: "1.5rem",
            alignItems: "center",
            listStyle: "none",
            margin: 0,
            padding: 0,
            marginLeft: "2rem",
            textTransform: "none",
          }}
        >
          {menuItems.map((item, idx) => (
            <li
              key={idx}
              style={{ position: "relative", cursor: "pointer" }}
              ref={
                item.dropdown === "about"
                  ? aboutDropdownRef
                  : item.dropdown === "news"
                  ? newsDropdownRef
                  : item.dropdown === "eservices"
                  ? eservicesDropdownRef
                  : null
              }
              onClick={() => item.dropdown && toggleDropdown(item.dropdown)}
            >
              <NavLink
                to={item.to}
                style={{ color: "white", textDecoration: "none", textTransform: "none" }}
              >
                {item.name} {item.dropdown ? "▼" : ""}
              </NavLink>

              {item.dropdown && openDropdown === item.dropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    backgroundColor: "white",
                    padding: "0.25rem 0.5rem",
                    borderRadius: "5px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                    minWidth: "220px",
                    zIndex: 10000,
                  }}
                >
                  <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                    {item.subItems.map((sub, i) => (
                      <li key={i} style={{ padding: "0.2rem 0" }}>
                        <Link
                          to={sub.to}
                          style={{ color: "black", textDecoration: "none", fontSize: "0.95rem", textTransform: "none" }}
                        >
                          {sub.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>

        {/* Hamburger Icon */}
        <div
          className="uk-hidden@l"
          style={{ color: "white", fontSize: "1.5rem", cursor: "pointer", marginLeft: "auto" }}
          onClick={() => setHamburgerOpen(!hamburgerOpen)}
        >
          {hamburgerOpen ? <FiX /> : <FiMenu />}
        </div>
      </div>

      {/* Hamburger Menu */}
      {hamburgerOpen && (
        <div
          className="uk-hidden@l"
          style={{
            backgroundColor: "#0f2495",
            color: "white",
            position: "absolute",
            top: "60px",
            left: 0,
            width: "100%",
            zIndex: 9998,
            padding: "0.3rem 1rem",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {menuItems.map((item, idx) => (
            <div key={idx}>
              <div
                onClick={() => item.dropdown && toggleMobileDropdown(item.dropdown)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.25rem 0",
                  cursor: "pointer",
                  fontWeight: item.dropdown ? "bold" : "normal",
                  fontSize: "0.95rem",
                  textTransform: "none",
                }}
              >
                <Link
                  to={item.to}
                  onClick={() => !item.dropdown && setHamburgerOpen(false)}
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {item.name}
                </Link>
                {item.dropdown &&
                  (mobileDropdowns[item.dropdown] ? <FiChevronUp /> : <FiChevronDown />)}
              </div>

              {item.dropdown && mobileDropdowns[item.dropdown] && (
                <div style={{ paddingLeft: "1rem", display: "flex", flexDirection: "column" }}>
                  {item.subItems.map((sub, i) => (
                    <Link
                      key={i}
                      to={sub.to}
                      onClick={() => setHamburgerOpen(false)}
                      style={{
                        color: "white",
                        textDecoration: "none",
                        padding: "0.15rem 0",
                        fontSize: "0.9rem",
                        textTransform: "none",
                      }}
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Navbar;
